import { render, staticRenderFns } from "./ApplicationActivityTab.vue?vue&type=template&id=b40168c0&"
import script from "./ApplicationActivityTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationActivityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports